import { render, staticRenderFns } from "./SelfscanningCompleted.vue?vue&type=template&id=df4b695c"
import script from "./SelfscanningCompleted.vue?vue&type=script&lang=js"
export * from "./SelfscanningCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports